import { Base64 } from 'js-base64'

export default {
  // 获取存储的数据
  get (key) {
    let value = localStorage.getItem(Base64.encode(key))
    if (value) {
      return JSON.parse(Base64.decode(value))
    }
    return false
  },
  // 存储数据，并用 base64 加密
  set (key, value) {
    key = Base64.encode(key)
    value = Base64.encode(JSON.stringify(value))
    localStorage.setItem(key, value)
  },
  // 删除存储的数据
  remove (key) {
    localStorage.removeItem(Base64.encode(key))
  }
}
